import { datadogLogs } from '@datadog/browser-logs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

datadogLogs.init({
    clientToken: process.env.REACT_APP_DD_ONB_WEB_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'onboarding-web',
    env: process.env.NODE_ENV,
    forwardErrorsToLogs: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
